const options = {
  cover: "bg-cover",
  contain: "bg-contain",
  auto: "bg-auto",
};

export default function getBgImageSize(bgSize) {
  return options[bgSize];
}
